import React, { useEffect, useState } from 'react';
import { cellRendererCheck, dateFormate } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';

const columns = [
    {
        dataField: 'options',
        text: 'Options',
        sort: false,
        width: 100,
        show: true,
        inputType: 'text',
        hidecolFilter: true, 
        action: true
    },
    {
        dataField: 'dateOfDispense',
        text: 'Fill Date',
        sort: false,
        width: 140,
        show: true,
        hideColFilter: true,
        cellRenderer: (rowData) => dateFormate(rowData.dateOfDispense),
    },
    {
        dataField: 'dateRxWritten',
        text: 'Date Rx Written',
        sort: true,
        width: 140,
        show: true,
        inputType: 'date',
        cellRenderer: (rowData) => dateFormate(rowData.dateRxWritten),
    },
    {
        dataField: 'gwClaimID',
        text: 'Claim ID',
        sort: true,
        width: 140,
        show: true,
        inputType: 'number',
        cellRenderer: (rowData) => cellRendererCheck(rowData.gwClaimID),
    },
    {
        dataField: 'prescriptionNumber',
        text: 'Rx #',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData) => cellRendererCheck(rowData.prescriptionNumber),
    },
    {
        dataField: 'fillNumber',
        text: 'Refill Code',
        sort: true,
        width: 140,
        show: true,
        inputType: 'number',
        cellRenderer: (rowData) => cellRendererCheck(rowData.fillNumber),
    },
    {
        dataField: 'prescriberFirstName',
        text: 'Prescriber First Name',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData) => cellRendererCheck(rowData.prescriberFirstName),
    },
    {
        dataField: 'prescriberLastName',
        text: 'Prescriber Last Name',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData) => cellRendererCheck(rowData.prescriberLastName),
    },
    {
        dataField: 'prescriberNPI',
        text: 'Prescriber NPI',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData) => cellRendererCheck(rowData.prescriberNPI),
    },
    {
        dataField: 'quantity',
        text: 'Qty Dispensed',
        sort: true,
        width: 140,
        show: true,
        inputType: 'number',
        cellRenderer: (rowData) => cellRendererCheck(rowData.quantity),
    },
    {
        dataField: 'bin',
        text: 'BIN',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData) => cellRendererCheck(rowData.bin),
    },
    {
        dataField: 'pcn',
        text: 'PCN',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData) => cellRendererCheck(rowData.pcn),
    },
    {
        dataField: 'group',
        text: 'Group',
        sort: false,
        width: 140,
        show: true,
        inputType: 'text',
        hideColFilter: true,
        cellRenderer: (rowData) => cellRendererCheck(rowData.group),
    },
    {
        dataField: 'createdDate',
        text: 'Captured Date ',
        sort: false,
        width: 140,
        show: true,
        inputType: 'date',
        hideColFilter: false,
        cellRenderer: (rowData) => dateFormate(rowData.createdDate),
    },
];

const AccumulationTable = ({
    tenantID,
    data,
    loading,
    onExport,
    filters,
    totalSize,
    onPageChange,
    refetch,
    setLoading,
    onSearchColumnFilters,
    reset,
}) => {
    const [state, updateState] = useState({
        tableData: [],
        backUpData: [],
        filters: filters,
    });
    useEffect(() => {
        setState({ tableData: data, backUpData: data });
    }, [data]);
    const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));

    useEffect(() => {
        setState({ filters: filters });
    }, [filters]);

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        onPageChange(filter);
    };

    const handleFilterCancel = () => {
        refetch(true);
    };

    const handleSearchColumnFilters = (colFilter) => {
        if (onSearchColumnFilters) {
            const filter = { ...state.filters, filters: colFilter, currentPage: 1 };
            onSearchColumnFilters(filter);
            setState({
                filters: filter,
            });
        }
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        } else {
            setState({
                filters: filter,
            });
            onPageChange(filter);
        }
    };

    const handleSort = (filter, hasColFilter) => {
        setState({
            filters: filter,
        });
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
        }
    };

    const { filters: colFilter, backUpData } = state;


    return <div className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={data.length > 0 ? 'fixed-height' : 'default'}>
        <ReactStrapTable
            id='inventory-table'
            fixedColumn
            data={backUpData}
            loading={loading}
            columns={columns}
            hasScrollArrow={false}
            onPageSizeChange={onPageSizeChange}
            pageSize={colFilter.pageSize}
            onExport={onExport}
            hasPagination
            onPageChange={onHandlePageChange}
            currentPage={colFilter.currentPage}
            totalRecords={totalSize}
            handleSort={handleSort}
            onFilterCancel={handleFilterCancel}
            filters={colFilter}
            onSearchColumnFilters={handleSearchColumnFilters}
        />
    </div>;
};

export default AccumulationTable;
